import React, { useState, useCallback, useEffect, forwardRef } from "react";
import {
  FormLayout,
  TextField,
  Text,
  InlineStack,
  RadioButton,
  Checkbox,
  Select,
} from "@shopify/polaris";
import { HexColorPicker } from "react-colorful";

const TypographyStyle = (props) => {
  const handleSelectChangeFontFamily = (newValue) => {
    props.handleSelectChangeFontFamily(newValue);
  };
  const handleChangeTextTransform = (_checked, newValue) => {
    props.handleChangeTextTransform(_checked, newValue);
  };
  const handleSelectChangeFontColor = (newValue) => {
    props.handleSelectChangeFontColor(newValue);
  };
  const handleChangeFontSize = (newValue) => {
    props.handleChangeFontSize(newValue);
  };
  const handleChangeFontSizeMobile = (newValue) => {
    props.handleChangeFontSizeMobile(newValue);
  };
  const optionsFonts = [
    { label: "Helvetica (sans-serif)", value: "1" },
    { label: "Arial (sans-serif)", value: "2" },
    { label: "Arial Black (sans-serif)", value: "3" },
    { label: "Verdana (sans-serif)", value: "4" },
    { label: "Tahoma (sans-serif)", value: "5" },
    { label: "Trebuchet MS (sans-serif)", value: "6" },
    { label: "Impact (sans-serif)", value: "7" },
    { label: "Gill Sans (sans-serif)", value: "8" },
    { label: "Times New Roman (serif)", value: "9" },
    { label: "Georgia (serif)", value: "10" },
    { label: "Palatino (serif)", value: "11" },
    { label: "Baskerville (serif)", value: "12" },
    { label: "Andalé Mono (monospace)", value: "13" },
    { label: "Courier (monospace)", value: "14" },
    { label: "Lucida (monospace)", value: "15" },
    { label: "Monaco (monospace)", value: "16" },
    { label: "Bradley Hand (cursive)", value: "17" },
    { label: "Brush Script MT (cursive)", value: "18" },
    { label: "Luminari (fantasy)", value: "19" },
    { label: "Comic Sans MS (cursive)", value: "20" },
  ];
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        TYPOGRAPHY
      </Text>
      <Text as="p" fontWeight="medium">
        Family Font
      </Text>
      <Select
        options={optionsFonts}
        onChange={handleSelectChangeFontFamily}
        value={
          props?.item?.typography?.fontFamily
            ? props?.item?.typography?.fontFamily
            : ""
        }
        placeholder="Please select"
      />
      <Text as="p" fontWeight="medium">
        Text Transform
      </Text>
      <InlineStack gap="200" align="start" blockAlign="center">
        <RadioButton
          label="Uppercase"
          checked={props?.item?.typography?.textTransform === "uppercase"}
          id="uppercase"
          onChange={handleChangeTextTransform}
        />
        <RadioButton
          label="Lowercase"
          checked={props?.item?.typography?.textTransform === "lowercase"}
          id="lowercase"
          onChange={handleChangeTextTransform}
        />
        <RadioButton
          label="Capitalize"
          checked={props?.item?.typography?.textTransform === "capitalize"}
          id="capitalize"
          onChange={handleChangeTextTransform}
        />
      </InlineStack>
      <Text as="p" fontWeight="medium">
        Text Color
      </Text>
      <HexColorPicker
        color={
          props?.item?.typography?.fontColor
            ? props?.item?.background?.fontColor
            : ""
        }
        onChange={handleSelectChangeFontColor}
      />
      <TextField
        value={
          props?.item?.typography?.fontColor
            ? props?.item?.typography?.fontColor
            : ""
        }
        onChange={handleSelectChangeFontColor}
      />
      <FormLayout.Group>
        <FormLayout>
          <Text variant="headingXs" as="h6">
            DESKTOP
          </Text>
          <TextField
            label="Font Size"
            value={
              props?.item?.typography?.fontSize?.desktop
                ? props?.item?.typography?.fontSize?.desktop
                : ""
            }
            onChange={handleChangeFontSize}
            type="number"
          />
        </FormLayout>
        <FormLayout>
          <Text variant="headingXs" as="h6">
            MOBILE
          </Text>

          <TextField
            label="Font Size"
            value={
              props?.item?.typography?.fontSize?.mobile
                ? props?.item?.typography?.fontSize?.mobile
                : ""
            }
            onChange={handleChangeFontSizeMobile}
            type="number"
          />
        </FormLayout>
      </FormLayout.Group>
    </FormLayout>
  );
};

export default TypographyStyle;
